import type { Locale } from "../../shared/api/types";
import { authText } from "../../shared/i18n/authText";
import type { usePasskeySignIn } from "./passkeySignIn";

/**
 * "or" + "Sign in with a passkey" + its error line, under a password form. One block for the login page (batch 18 GRF-46) and
 * the session-expired dialog (batch 21 GRF-70), so both entry points look and behave the same. Renders nothing when the
 * Passkeys flag is off or the browser cannot do WebAuthn (`passkey.available`).
 */
export function PasskeySignInOption({ passkey, locale }: { passkey: ReturnType<typeof usePasskeySignIn>; locale: Locale }) {
  if (!passkey.available) return null;
  return (
    <div className="stack gf-passkey-signin">
      <p className="gf-login-or" aria-hidden="true">
        <span>{authText("passkeyOr", locale)}</span>
      </p>
      <button type="button" className="btn sec" disabled={passkey.busy} onClick={passkey.signInWithButton}>
        {passkey.busy ? authText("passkeyBusy", locale) : authText("passkeyButton", locale)}
      </button>
      {passkey.error && (
        <p className="msg" role="alert">
          {passkey.error}
        </p>
      )}
    </div>
  );
}
